import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import style from "./styled-markdown.module.css";

interface StyledMarkdownProps {
  children?: string;
}

export const StyledMarkdown = (props: StyledMarkdownProps) => {
  return (
    <Markdown
      className={style.markdown}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        a: ({ node, ...anchorProps }) => (
          <a {...anchorProps} target="_blank" rel="noopener noreferrer" />
        ),
      }}
    >
      {props.children}
    </Markdown>
  );
};
